import React, { useMemo, useState, useRef } from 'react'
import { Wrapper, TextDetail, Panel, TextAreaIcon, SelectFieldIcon } from '../_components'
import Axios from 'axios'
import moment from 'moment'
import avatar from '../_images/avatar.png'
import { Formik } from 'formik'

export default function () {
    const [ comments, setComments ] = useState( [] )

    const [ loading, setLoading ] = React.useState( true )
    const [ record, setRecord ] = useState( null )
    const [ files, setFiles ] = useState( [] )
    const [ auditReport, setAuditReport ] = useState( [] )
    const ref = useRef(null);

    React.useEffect( () => {
        if( loading ) {
            fetchApplication()
            fetchAuditReport()
            fetchAuditReportFile()
        }
    },[ loading ])

    const fetchApplication = async () => {
        try {
            const response =  await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication/${localStorage.getItem( "applicationId" )}` )

            if( response.data ) {
                setRecord( response.data.record )
                setLoading( false )
            }
        } catch (error) {
            setLoading( false )
        }
    }

    const fetchAuditReportFile = async () => {
        let applicationId = localStorage.getItem( "applicationId" )
        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getAuditReportFile/${applicationId}` )
            if( response.data ){
                setFiles( response.data?.data )
            }
        } catch (error) {}
    }

    const fetchAuditReport = async () => {
        let applicationId = localStorage.getItem( "applicationId" )
        try {
          const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getAuditReport/${applicationId}` )
          if( response.data ){
            setAuditReport( response.data )
          }
        } catch (error) {}
    }

    const previewFile = async (e) => {
        let file_id = e.target.id
        
        try {
            const email = btoa(localStorage.getItem( "email" )); // Base64 encode
            const url = process.env.REACT_APP_API_URL+`/api/auth/get_file_details/${file_id}/${email}`
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        } catch (error) {}
    }

    const handleClientAuditFeedback  = async ( values ) => {
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
                id: record?.id,
                email_address: record?.created_by,
                actioned_by: localStorage.getItem( "username" ),
                comments: values.comments,
                action: values.action,
                client_reaction_to_audit: values.action,
                role: localStorage.getItem( "role" )
            } )

            if( response.data ) {
                alert( response.data.message )
                await localStorage.setItem( "link", "welcome" )
                return window.location.reload()
            }
        } catch (error) {}
    }

    return (
        <Wrapper>
            {loading ? (
                <div className="flex items-center justify h-full w-full">
                    {`Loading...`}
                </div>
            )
            :(<div className="bg-gray-100 h-full overflow-y-scroll grid gap-3 px-10 py-3">
            
            <div className="h-full bg-white rounded-sm grid">
                <div className="border-b border-gray-300 flex flex-row">
                <div className="flex flex-row items-center px-2">
                    {/* <button className="text-sm underline text-red-500" onClick={() => alert("back")}>Back</button> */}
                    <h2 className="p-5 text-sm font-bold uppercase">
                    {`Auditor's Report for`}
                    </h2> <div className="text-blue-600 font-extrabold pb-1">{record?.trading_name}</div>
                </div>
                <div />
                </div>

                <div className="border-b border-gray-300 p-4">
                    <div className="h-full border border-gray-200 flex flex-row items-center justify-between rounded-sm">
                        <div className="grid gap-2 px-2" style={{ gridTemplateRows: "1rem auto"}}>
                            <h5 className="text-start text-xs uppercase">
                                {`Applicant`}
                            </h5>
                            <div className="flex flex-row px-2">
                                <div className="rounded-full border border-gray-200 overflow-hidden flex items-center justify-center w-10 h-10">
                                    <img src={avatar} alt="Profile Image" className="rounded-full" />
                                </div>
                                <div className="flex flex-col items-start justify-center px-2">
                                    <p className="text-xs">
                                        {/* {capitalizeName( record?.first_name + " " +  record?.surname )} */}
                                    </p>
                                    <p className="text-xs">
                                        {/* {record?.telephone} */}
                                    </p>
                                    <p className="text-xs">
                                        {/* {record?.email_address} */}
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="flex flex-col">
                            <TextDetail label="Created Date" val={moment( record?.created_at ).format( "DD-MMM-YYYY" )} />
                            <TextDetail label="Client Email Address" val={record?.created_by} />
                            <TextDetail label="Category" val={record?.category} />
                            <TextDetail label="Status" val={record?.status || "ONGOING"} color="red" />
                        </div>
                        <div />
                    </div>
                </div>

                <div className="w-full">                
                    <Panel label="Application Particulars">
                        <div className="grid grid-cols-2 gap-2 items-center">
                                {record?.category === "Individual" && [
                                    { label: "Category", value: record?.category, name: "category" },
                                    { label: "Given Name/ First Name", value: record?.given_name, name: "given_name" },
                                    { label: "Surname", value: record?.surname, name: "surname" },
                                    { label: "Other Name", value: record?.middle_name, name: "other_name" },
                                    { label: "Nationality", value: record?.nationality, name: "nationality" },
                                    { label: record?.nationality === "Ugandan" ? "National ID" : "Passport No.", value: record?.nationality === "Ugandan" ? record?.national_id : record?.passport_number, name: "national_id" },
                                    { label: "Taxpayer Identification Number", value: record?.tin, name: "tin" }
                                ].map( val => {
                                    return (
                                    <TextDetail label={val.label} val={val.value} key={val.value}/>
                                    )
                                } )}

                                {record?.category === "Company" && [
                                    { label: "Certification Level", value: record?.certification_level, name: "certification_level" },
                                    { label: "Contact First Name", value: record?.contact_first_name, name: "contact_first_name" },
                                    { label: "Contact Last Name", value: record?.contact_last_name, name: "contact_last_name" },
                                    { label: "Other Name", value: record?.contact_middle_name, name: "contact_middle_name" },
                                    { label: "TIN", value: record?.tin, name: "tin" },
                                ].map( val => {
                                    return (
                                    <TextDetail label={val.label} val={val.value} key={val.value} />
                                    )
                                } )}
                            </div>

                            <div className="grid grid-cols-2 gap-2 items-center">
                            {[
                                { label: "Date of Incorporation", value: record?.doc, name: "doc" },
                                { label: "Name of Entity", value: record?.entity_name, name: "entity_name" },
                                { label: "Entity Registration", value: record?.entity_registration, name: "entity_registration" },
                                { label: "Entity Type", value: record?.entity_type, name: "entity_type" },
                                { label: "BRN", value: record?.ern, name: "ern" },
                                { label: "Membership", value: record?.membership, name: "membership" },
                                { label: "Service Type", value: record?.service_type, name: "service_type" },
                                { label: "Business Trading Name", value: record?.trading_name, name: "trading_name" },
                                { label: "Website", value: record?.website, name: "website" },
                            ].map( val => {
                                return (
                                    <TextDetail label={val.label} val={val.value} key={val.value} />
                                )
                            } )}
                        </div> 
                    </Panel>

                    <Panel label="Audit Report">
                    <table className="text-gray-700 py-1 text-xs border-collapse mt-2 w-full overflow-x-scroll">
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Type of Audit</th>
                            <td className="border border-slate-300">{auditReport?.type_of_audit}</td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Applicable Regulation</th>
                            <td className="border border-slate-300">{auditReport?.applicable_regulation || "NITA-U (Certification of Providers of IT Products and Services) (Amendment) Regulation 2018"}</td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Applicable Standard(s)</th>
                            <td className="border border-slate-300">{auditReport?.applicable_standard}</td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">ISIC Codes</th>
                            <td className="border border-slate-300">{auditReport?.isic_codes}</td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Audit Site</th>
                            <td className="border border-slate-300">{auditReport?.audit_site}</td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Audit Date</th>
                            <td className="border border-slate-300">{auditReport?.audit_date}</td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Distribution/Confidentiality/Rights of <br/>bownership/Limitations/Responsibilities</th>
                            <td className="border border-slate-300">{auditReport?.distribution_limitations_responsibilties}</td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Audit Criteria</th>
                            <td className="border border-slate-300">{auditReport?.audit_criteria}</td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Proof of Legal Status</th>
                            <td className="border border-slate-300">
                                {auditReport?.proof_of_legal_status}<br/>
                                - <b>{auditReport?.proof_of_legal_status_comment}</b>
                            </td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Proof of registration for <br/>tax purposes</th>
                            <td className="border border-slate-300">
                                {auditReport?.proof_of_registration}<br/>
                                - <b>{auditReport?.proof_of_registration_comment}</b>
                            </td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Proof of Office location and <br/>necessary facilities, equipment <br/>and infrastructure</th>
                            <td className="border border-slate-300">
                                {auditReport?.proof_of_office_location}<br/>
                                - <b>{auditReport?.proof_of_office_location_comment}</b>
                            </td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Proof of IT Personnel used to <br/>provide IT Services</th>
                            <td className="border border-slate-300">
                                {auditReport?.proof_of_it_personnel}<br/>
                                - <b>{auditReport?.proof_of_it_personnel_comment}</b>
                            </td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Proof of applicable quality<br/> and technical manuals</th>
                            <td className="border border-slate-300">
                                {auditReport?.proof_of_manuals}<br/>
                                - <b>{auditReport?.proof_of_manuals_comment}</b>
                            </td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Proof of satisfactory past services<br/> provided in the field of IT service/product<br/> for which certification is sought</th>
                            <td className="border border-slate-300">
                                {auditReport?.proof_of_past_services}<br/>
                                - <b>{auditReport?.proof_of_past_services_comment}</b>
                            </td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Audit Notes</th>
                            <td className="border border-slate-300">{auditReport?.audit_notes} </td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Auditee Members</th>
                            <td className="border border-slate-300">{auditReport?.auditee_members} </td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Report added on</th>
                            <td className="border border-slate-300">{moment( auditReport?.created_at ).format("DD MMM, YYYY")}</td>
                            </tr>
                            <tr className="text-xs p-5 text-left">
                            <th className="border border-slate-300 p-2">Submitted By</th>
                            <td className="border border-slate-300">{auditReport?.created_by}</td>
                            </tr>
                        </table>

                        <table className="w-full border">
                            <thead className="text-xs bg-gray-200 font-bold p-2">
                                <th className="p-2">#</th>
                                <th>Name</th>
                                <th>Size</th>
                                <th>Action</th>
                                <th>Date Created</th>
                            </thead>
                            <tbody>
                                {files?.map( ( item, index ) => {
                                    return (
                                        <tr key={index} className="text-xs p-2 text-center">
                                            <td className="p-2">{`${index+1}`}</td>
                                            <td>{item.name}</td>
                                            <td>{item.size}</td>
                                            <td>
                                                {/* <a className="bg-red-500 text-xs text-white px-2 py-1" href={item.file} download={item.name}>Download</a> */}

                                                <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" ref={ref} id={item.id} onClick={previewFile}>View File</a>
                                            </td>
                                            <td>{moment( item.created_at ).format("DD MMM, YYYY")}</td>
                                        </tr>
                                    )
                                } )}
                            </tbody>
                        </table>
                    </Panel>

                    {localStorage.getItem( "role" )?.toUpperCase().includes("APPLICANT") && <Panel label="Auditor's Report Feedback">
                        <div className="flex flex-col items-start justify-center px-5 py-2">
                            <Formik initialValues={{
                                action: comments[ 0 ]?.action || "",
                                actioned_by: localStorage.getItem( "username" ),
                                comments: comments[ 0 ]?.comments || ""
                                }} onSubmit={handleClientAuditFeedback}>
                                { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                                    return (
                                        <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                            <div className="w-full grid grid-rows-2 gap-1">
                                                <SelectFieldIcon 
                                                    name="action"
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    value={values.action}
                                                    label="Action"
                                                    required={true}
                                                    disabled={comments[ 0 ]?.action ? true : false}
                                                    options={[ 
                                                        { id: 1, value: "Accept", label: "Accept" },
                                                        { id: 2, value: "Reject", label: "Reject" }
                                                    ]}
                                                    question="Feedback" />
                                                <TextAreaIcon
                                                    rows={3}
                                                    cols={5}
                                                    name="comments"
                                                    value={values.comments}
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    label="Comments"
                                                    disabled={comments[ 0 ]?.action ? true : false}
                                                    question={`Add any comments/remarks`}
                                                    required={true}
                                                />
                                            </div>

                                            {! ( comments[ 0 ]?.action ) && 
                                            ( <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                                {`Submit`}
                                            </button> ) }
                                        </form>
                                    )
                                }  }
                            </Formik>
                        </div>
                    </Panel>
                    }
                </div>
            </div>
            </div> ) }
        </Wrapper>
    )
}

